import type { MusicImportCandidate, MusicImportJob, MusicImportQueueResponse, MusicImportResolveResponse, MusicImportStatus } from "@needle-drop/shared";
import { apiRequest } from "./cloudLibrary";

export async function resolveMusicImport(apiBaseUrl: string, input: string, signal?: AbortSignal): Promise<MusicImportResolveResponse> {
  const response = await apiRequest(apiBaseUrl, "/api/music-import/resolve", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ input }),
    ...(signal ? { signal } : {}),
  });
  return await response.json() as MusicImportResolveResponse;
}

export async function fetchMusicImportQueue(apiBaseUrl: string): Promise<MusicImportQueueResponse> {
  return await (await apiRequest(apiBaseUrl, "/api/music-import/queue", { cache: "no-store" })).json() as MusicImportQueueResponse;
}

export async function addMusicImportCandidate(apiBaseUrl: string, candidate: MusicImportCandidate): Promise<MusicImportCandidate | undefined> {
  const { id: _id, status: _status, createdAt: _createdAt, updatedAt: _updatedAt, ...payload } = candidate;
  const response = await apiRequest(apiBaseUrl, "/api/music-import/queue", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  return (await response.json() as { item?: MusicImportCandidate }).item;
}

export async function updateMusicImportStatus(apiBaseUrl: string, id: string, status: MusicImportStatus): Promise<MusicImportCandidate | undefined> {
  const response = await apiRequest(apiBaseUrl, `/api/music-import/queue/${id}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ status }),
  });
  return (await response.json() as { item?: MusicImportCandidate }).item;
}

export async function deleteMusicImportCandidate(apiBaseUrl: string, id: string) {
  await apiRequest(apiBaseUrl, `/api/music-import/queue/${id}`, { method: "DELETE" });
}

export async function startCloudMusicImport(apiBaseUrl: string, playlistName: string, candidateIds: string[]): Promise<MusicImportJob> {
  const response = await apiRequest(apiBaseUrl, "/api/music-import/cloud", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ playlistName, candidateIds }),
  });
  return (await response.json() as { job: MusicImportJob }).job;
}

export async function fetchCloudMusicImport(apiBaseUrl: string, id: string): Promise<MusicImportJob> {
  const response = await apiRequest(apiBaseUrl, `/api/music-import/cloud/${id}`, { cache: "no-store" });
  return (await response.json() as { job: MusicImportJob }).job;
}
